const ApiUrl = `${process.env.VUE_APP_API_PP_CIUDADANO}`
const ApiPPUrl = `${process.env.VUE_APP_API_PP_PARTIDOS}`

import axios from 'src/interceptor'

export const requestSolicitudMixin = {
  methods: {
    getListaSolicitud(body) {
      return axios.post(`${ApiUrl}/ciudadanohistorico/solicitud/lista`, body)
    },
    getSolicitudHistoricaView(id) {
      const body = { id: id}
      return axios.post(`${ApiUrl}/ciudadanohistorico/solicitud/ver`, body)
    },
    crearSolicitud(body) {
      return axios.post(`${ApiPPUrl}/partidohistorico/solicitud/crear`, body);
    }
  }
};
